import { render, staticRenderFns } from "./TaskLogViewRecord.vue?vue&type=template&id=228186de"
import script from "./TaskLogViewRecord.vue?vue&type=script&lang=js"
export * from "./TaskLogViewRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports